import { connect } from 'react-redux';
import notify from '@/migration/notification';
import {
  compose,
  lifecycle,
  setDisplayName,
  withHandlers,
  withState,
} from 'recompose';
import { bindActionCreators } from 'redux';
import { salesAction, usersAction } from '@/actions';
import { constants } from '../../../../constants';

const mapStateToProps = (state) => ({
  sales: state.sales.toJS(),
  users: state.users.toJS(),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...salesAction, ...usersAction, notify }, dispatch);

const enhance = compose(
  setDisplayName('AuctionItems'),
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'updateLoading', true),
  withState('showModal', 'updateShowModal', false),
  withState('isPaginationDisabled', 'updatePaginationDisabled', false),

  withHandlers({
    onChangePage: (props) => async (current) => {
      const {
        updateMyPagePagesActive,
        getSalesForMyPage,
        updatePaginationDisabled,
        users: { mydata },
      } = props;

      updateMyPagePagesActive(current);
      updatePaginationDisabled(true);
      getSalesForMyPage(
        { limit: 15, page: current },
        { seller: [`${mydata.id}`], closed: [0, 1, 2, 3] },
        ['-created_at']
      );
      updatePaginationDisabled(false);
    },
  }),
  lifecycle({
    async componentDidMount() {
      const {
        getMe,
        getSalesForMyPage,
        updateLoading,
        updateMyPagePagesActive,
        getMyFollows,
      } = this.props;

      const me = await getMe();
      await getMyFollows(me.value.id);
      await getSalesForMyPage(
        { limit: 15, page: constants.PAGINATION.INITIAL },
        { seller: [`${me.value.id}`], closed: [0, 1, 2, 3] },
        ['-created_at']
      );
      updateMyPagePagesActive(constants.PAGINATION.INITIAL);
      updateLoading(false);
    },
    componentWillUnmount() {
      const { initializeSalesForMyPage } = this.props;
      initializeSalesForMyPage();
    },
  })
);

export default enhance;
